// import React from 'react'

// import AboutCTR from '../containers/about/AboutCTR'

// function About() {
//     return (
//         <>
//             <AboutCTR />
//         </>
//     )
// }

// export default About


import React from 'react'
import { Helmet } from 'react-helmet-async';

import AboutCTR from '../containers/about/AboutCTR'

function About() {
    return (
        <>
            {/* <Helmet>
                <title>About Bonvoy Tourism | Dubai's 5-Star Rated Tour Operator</title>
                <meta
                    name="description"
                    content="Bonvoy Tourism is Dubai's most trusted tour operator with 60+ five-star reviews. Expert guides, best price guarantee & 24/7 support. Learn our story."
                />
                <link rel="canonical" href="https://bonvoytourism.com/about" />
            </Helmet> */}
            <Helmet>
                <title>About Bonvoy Tourism | Dubai's No.1 Rated Tour Operator</title>
                <meta
                    name="description"
                    content="Bonvoy Tourism — Dubai's top-rated tour company with a 5.0 ★ TripAdvisor rating. Learn our story, meet our expert guides Rashid & Taj, and discover why 60,000+ travellers trust us for desert safaris, city tours & UAE experiences."
                />
                <link rel="canonical" href="https://bonvoytourism.com/about" />

                <meta property="og:title" content="About Bonvoy Tourism | Dubai's No.1 Rated Tour Operator" />
                <meta property="og:description" content="Dubai's No.1 rated tour operator. 5.0 ★ TripAdvisor · 60+ reviews. Desert safaris, city tours, dhow cruises & UAE day trips. Hotel pickup included." />
                <meta property="og:url" content="https://bonvoytourism.com/about" />
                <meta property="og:image" content="https://bonvoytourism.com/images/destination/destination3.webp" />
            </Helmet>

            <AboutCTR />
        </>
    )
}

export default About